namespace TabAurous.Retail {
    export namespace POSSalesDayWiseService {
        export const baseUrl = 'Retail/POSSalesDayWise';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSSalesDayWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSSalesDayWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
